(() => {
  document.querySelectorAll('.vl-guide').forEach(root => {
    if (root.dataset.initialized) return;
    root.dataset.initialized = 'true';
    const video = root.querySelector('[data-guide-video]');
    const cover = root.querySelector('.vl-play-cover');
    const error = root.querySelector('.vl-video-error');
    const cards = root.querySelector('.vl-cards');
    const sticky = root.querySelector('.vl-sticky');
    const product = root.querySelector('[data-product-section]');
    const offers = root.querySelector('#vl-wszystkie-produkty');
    const reduced = matchMedia('(prefers-reduced-motion: reduce)').matches;
    const behavior = reduced ? 'instant' : 'smooth';
    const sent = new Set();
    const emit = (event, once = false) => {
      if (once && sent.has(event)) return;
      sent.add(event);
      root.dispatchEvent(new CustomEvent('verdelove:guide', {bubbles:true, detail:{guide_id:'marta_01',event}}));
    };
    root.querySelectorAll('[data-play]').forEach(button => button.addEventListener('click', async () => {
      cover.hidden = true;
      try { await video.play(); error.hidden = true; }
      catch { error.hidden = false; }
      if (!button.classList.contains('vl-play-cover')) video.scrollIntoView({behavior,block:'center'});
    }));
    video.addEventListener('play', () => { cover.hidden = true; emit('video_start',true); });
    video.addEventListener('timeupdate', () => { if (video.duration && video.currentTime / video.duration >= .5) emit('video_half',true); });
    video.addEventListener('ended', () => emit('video_complete',true));
    root.querySelectorAll('[data-product-link]').forEach(a => a.addEventListener('click', () => emit('product_click')));
    root.querySelectorAll('.vl-product-form').forEach(form => form.addEventListener('submit', () => emit('cart_intent')));
    root.querySelectorAll('[data-allegro-link]').forEach(link => link.addEventListener('click', () => emit('allegro_click')));
    const reviews = root.querySelector('.vl-review-track');
    root.querySelectorAll('[data-review-slide]').forEach(button => button.addEventListener('click', () => {
      if (!reviews) return;
      const gap = parseFloat(getComputedStyle(reviews).gap) || 0;
      reviews.scrollBy({left:Number(button.dataset.reviewSlide)*(reviews.firstElementChild.getBoundingClientRect().width+gap),behavior});
    }));
    if (reviews) {
      const resizeReviews = () => {
        const area = reviews.getBoundingClientRect();
        const visible = [...reviews.children].filter(card => {
          const rect = card.getBoundingClientRect();
          return rect.right > area.left + 2 && rect.left < area.right - 2;
        });
        reviews.style.height = `${Math.max(...visible.map(card => card.getBoundingClientRect().height),0)+28}px`;
      };
      reviews.addEventListener('scroll',resizeReviews,{passive:true});
      addEventListener('resize',resizeReviews);
      if (typeof ResizeObserver !== 'undefined') {
        const observer = new ResizeObserver(resizeReviews);
        [...reviews.children].forEach(card => observer.observe(card));
      }
      resizeReviews();
    }
    const logoTrack = root.querySelector('.vl-logo-track');
    if (logoTrack) {
      const originals = [...logoTrack.children];
      originals.forEach(item => {
        const clone = item.cloneNode(true);
        clone.setAttribute('aria-hidden','true');
        clone.setAttribute('inert','');
        clone.dataset.logoClone = 'true';
        clone.querySelectorAll('a').forEach(a => a.removeAttribute('href'));
        if (clone.tagName === 'A') { clone.removeAttribute('href'); clone.removeAttribute('data-allegro-link'); }
        logoTrack.appendChild(clone);
      });
      let touching = false, focused = false, resumeAt = 0, lastTime = 0, position = logoTrack.scrollLeft;
      // Native touch scrolling owns the ribbon until the gesture and momentum finish.
      // A pointerup elsewhere on the page must never delay the initial animation.
      const resume = () => { resumeAt = performance.now()+700; position=logoTrack.scrollLeft; };
      logoTrack.addEventListener('touchstart',()=>{ touching=true; },{passive:true});
      logoTrack.addEventListener('touchend',event=>{ touching=event.touches.length>0; if(!touching) resume(); },{passive:true});
      logoTrack.addEventListener('touchcancel',()=>{ touching=false; resume(); },{passive:true});
      logoTrack.addEventListener('focusin',()=>{ focused=true; });
      logoTrack.addEventListener('focusout',event=>{ focused=logoTrack.contains(event.relatedTarget); });
      logoTrack.addEventListener('wheel',resume,{passive:true});
      logoTrack.addEventListener('scroll',()=>{
        if(touching || performance.now()<resumeAt) {
          position=logoTrack.scrollLeft;
          resumeAt=performance.now()+200;
        }
      },{passive:true});
      const animate = now => {
        if (!root.isConnected) return;
        const delta = lastTime ? Math.min(now-lastTime,50) : 0;
        lastTime=now;
        const rect=logoTrack.getBoundingClientRect();
        const firstClone=logoTrack.children[originals.length];
        const cycle=firstClone.getBoundingClientRect().left-originals[0].getBoundingClientRect().left;
        if (!reduced&&!touching&&!focused&&now>=resumeAt&&!document.hidden&&rect.bottom>0&&rect.top<innerHeight&&cycle>0) {
          position=(position+delta*0.032)%cycle;
          logoTrack.scrollLeft=position;
        } else position=logoTrack.scrollLeft;
        requestAnimationFrame(animate);
      };
      requestAnimationFrame(animate);
    }
    const ugc = root.querySelector('.vl-ugc-track');
    if (ugc) {
      const updateCount=()=>{
        const step=ugc.firstElementChild.getBoundingClientRect().width+(parseFloat(getComputedStyle(ugc).gap)||0);
        const index=Math.min(ugc.children.length,Math.round(ugc.scrollLeft/step)+1);
        root.querySelector('[data-ugc-count]').textContent=`${index} / ${ugc.children.length}`;
      };
      ugc.addEventListener('scroll',updateCount,{passive:true}); addEventListener('resize',updateCount); updateCount();
    }
    root.querySelectorAll('[data-ugc-slide]').forEach(button => button.addEventListener('click', () => {
      const step = ugc.firstElementChild.getBoundingClientRect().width + (parseFloat(getComputedStyle(ugc).gap) || 0);
      ugc.scrollBy({left:Number(button.dataset.ugcSlide)*step,behavior});
    }));
    const tips = root.querySelector('.vl-tip-track');
    root.querySelectorAll('[data-tip-slide]').forEach(button => button.addEventListener('click', () => {
      const gap = parseFloat(getComputedStyle(tips).gap) || 0;
      tips.scrollBy({left:Number(button.dataset.tipSlide)*(tips.firstElementChild.getBoundingClientRect().width+gap),behavior});
    }));
    root.querySelectorAll('[data-study]').forEach(button => button.addEventListener('click', () => {
      root.querySelectorAll('[data-study]').forEach(b => b.setAttribute('aria-pressed',String(b===button)));
      root.querySelectorAll('[data-study-result]').forEach(panel => { panel.hidden = panel.dataset.studyResult !== button.dataset.study; });
    }));
    // Zapamiętujemy wyłącznie oznaczenia kampanii i dopiero po zgodzie.
    const params = new URLSearchParams(location.search);
    const aliases = {fb:'facebook',ig:'instagram',an:'audience_network',msg:'messenger',th:'threads'};
    const source = params.get('utm_source');
    if (aliases[source]) params.set('utm_source',aliases[source]);
    const storageKey = 'vl_guide_attribution_v1';
    const lifetime = 30*24*60*60*1000;
    const safe = value => typeof value === 'string' && /^[a-zA-Z0-9_-]{1,100}$/.test(value);
    const validTouch = touch => touch && /^atopicin_[a-zA-Z0-9_-]+$/.test(touch.utm_campaign || '') &&
      ({facebook:['paid_social','social'],instagram:['paid_social','social'],audience_network:['paid_social'],messenger:['paid_social'],threads:['paid_social'],google:['cpc'],wp:['display','native','paid_referral'],newsletter:['email']}[touch.utm_source] || []).includes(touch.utm_medium) &&
      ['utm_campaign','utm_source','utm_medium','utm_content'].every(key => safe(touch[key]));
    const currentTouch = Object.fromEntries(['utm_campaign','utm_source','utm_medium','utm_content'].map(key => [key,params.get(key)]));
    const updateAttribution = () => {
      const allowed = Boolean(window.Shopify?.customerPrivacy?.analyticsProcessingAllowed?.());
      let saved = null;
      if (allowed) {
        try { saved = JSON.parse(localStorage.getItem(storageKey)); } catch {}
        if (!saved || !validTouch(saved.first) || !validTouch(saved.last) || !Number.isFinite(saved.started) || Date.now()-saved.started>lifetime || saved.started>Date.now()) {
          saved = null;
          try { localStorage.removeItem(storageKey); } catch {}
        }
        if (validTouch(currentTouch)) {
          saved = saved || {first:currentTouch,started:Date.now()};
          saved.last=currentTouch;
          try { localStorage.setItem(storageKey,JSON.stringify(saved)); } catch {}
        }
      } else if (window.Shopify?.customerPrivacy?.currentVisitorConsent?.().analytics === 'no') {
        try { localStorage.removeItem(storageKey); } catch {}
      }
      const touch = saved?.last;
      root.querySelectorAll('[data-attribution]').forEach(input => {
        const value = touch?.[input.dataset.attribution] || '';
        input.disabled = !allowed || !safe(value);
        input.value = input.disabled ? '' : value;
      });
      root.querySelectorAll('[data-page-attribution]').forEach(input => { input.disabled = !allowed || !touch; });
      root.querySelectorAll('form').forEach(form => {
        if (!form.querySelector('[data-attribution]')) return;
        ['campaign','source','medium','content'].forEach(key => {
          const name = `properties[_vl_first_${key}]`;
          let input = [...form.elements].find(element => element.name===name);
          if (!input) { input=document.createElement('input'); input.type='hidden'; input.name=name; form.appendChild(input); }
          const value=saved?.first?.['utm_'+key] || '';
          input.disabled=!allowed || !safe(value); input.value=input.disabled?'':value;
        });
      });
    };
    updateAttribution();
    document.addEventListener('visitorConsentCollected',updateAttribution);
    window.Shopify?.loadFeatures?.([{name:'consent-tracking-api',version:'0.1'}],error => { if (!error) updateAttribution(); });
    addEventListener('pageshow',updateAttribution);
    root.querySelectorAll('.vl-product-form').forEach(form => form.addEventListener('submit',updateAttribution));
    video.addEventListener('error', () => { cover.hidden = true; error.hidden = false; });
    root.querySelectorAll('[data-slide]').forEach(button => button.addEventListener('click', () => {
      const gap = parseFloat(getComputedStyle(cards).gap) || 0;
      const step = cards.firstElementChild.getBoundingClientRect().width + gap;
      cards.scrollBy({left: Number(button.dataset.slide) * step, behavior});
    }));
    root.querySelectorAll('a[href^="#vl-"]').forEach(a => a.addEventListener('click', event => {
      const target = root.querySelector(a.getAttribute('href'));
      if (!target) return;
      event.preventDefault(); target.scrollIntoView({behavior,block:'start'});
      history.replaceState(null,'',location.pathname+location.search+a.getAttribute('href'));
      if (!target.hasAttribute('tabindex')) target.setAttribute('tabindex','-1');
      target.focus({preventScroll:true});
    }));
    let stickyDismissed = false;
    root.querySelector('[data-sticky-close]')?.addEventListener('click', () => { stickyDismissed=true; sticky.hidden=true; });
    root.querySelectorAll('[data-demo-play]').forEach(button => {
      const demo = root.querySelector('#'+button.dataset.demoPlay);
      button.addEventListener('click', async () => {
        try { await demo.play(); button.hidden=true; }
        catch { button.textContent='Spróbuj odtworzyć ponownie'; }
      });
      demo.addEventListener('play', () => {
        root.querySelectorAll('video').forEach(other => { if(other!==demo) other.pause(); });
        button.hidden=true;
      });
      demo.addEventListener('ended', () => { button.hidden=false; });
    });
    let queued = false;
    const update = () => {
      const rect = root.getBoundingClientRect();
      const range = Math.max(1,root.offsetHeight-innerHeight);
      root.querySelector('.vl-progress span').style.width = `${Math.min(100,Math.max(0,-rect.top/range*100))}%`;
      const p = (product || offers).getBoundingClientRect();
      const shown = p.top < innerHeight && p.bottom > 0;
      if (shown) emit('product_visible',true);
      if (-rect.top / range >= .5) emit('guide_half',true);
      const offersRect = offers?.getBoundingClientRect();
      const offersShown = offersRect && offersRect.top < innerHeight && offersRect.bottom > 0;
      const early = root.querySelector('.vl-early-offer')?.getBoundingClientRect();
      const earlyShown = early && early.top < innerHeight && early.bottom > 0;
      sticky.hidden = stickyDismissed || rect.top > -innerHeight || shown || offersShown || earlyShown || rect.bottom < 120;
      queued = false;
    };
    addEventListener('scroll', () => { if (!queued) { queued = true; requestAnimationFrame(update); } }, {passive:true});
    addEventListener('resize',update); update();
  });
})();


// Shopify uses a native product form; local preview never modifies a real cart.
(() => {
  const dialog = document.querySelector('.vl-bundle-dialog');
  if (!dialog) return;
  const form = dialog.querySelector('[data-kit-form]');
  const items = [...dialog.querySelectorAll('[data-kit-item]')];
  const submit = dialog.querySelector('[data-kit-submit]');
  const status = dialog.querySelector('[data-kit-status]');
  const total = dialog.querySelector('[data-kit-total]');
  const error = dialog.querySelector('[data-kit-error]');
  const fullTotal = total.textContent;
  const fullStatus = status.textContent;
  const live = form.dataset.shopify === 'true';
  const shipping = dialog.querySelector('.vl-dialog-shipping');
  const comparison = dialog.querySelector('.vl-dialog-total small');
  const money = cents => new Intl.NumberFormat('pl-PL', {style:'currency',currency:'PLN'}).format(cents / 100);
  let trigger;
  let submitting = false;
  const update = () => {
    const selected = items.filter(i => i.checked);
    const count = selected.length;
    const price = selected.reduce((sum, item) => sum + Number(item.dataset.price), 0);
    submit.disabled = count === 0 || submitting;
    submit.textContent = submitting ? 'Przechodzę do koszyka…' : count === 3 ? 'Dodaj zestaw do koszyka' : 'Dodaj wybrane produkty do koszyka';
    status.textContent = count === 3 ? fullStatus : count ? `Wybrano ${count} z 3 produktów. Ceny bez rabatu zestawowego.` : 'Zaznacz przynajmniej jeden produkt.';
    total.textContent = count === 3 ? fullTotal : money(price);
    comparison.hidden = count !== 3;
    shipping.textContent = count === 3 || price >= 15000 ? 'Standardowa dostawa w Polsce: 0 zł.' : 'Standardowa dostawa w Polsce gratis od 150 zł. Koszt dostawy sprawdzisz w koszyku i kasie.';
    items.forEach(item => { item.disabled = submitting; });
    error.hidden = true;
  };
  const reset = () => { items.forEach(i => { i.checked = true; }); submitting = false; update(); };
  document.querySelectorAll('[data-bundle-open]').forEach(button => button.addEventListener('click', () => {
    trigger=button; reset(); dialog.showModal();
  }));
  dialog.querySelector('[data-kit-close]').addEventListener('click', () => dialog.close());
  dialog.addEventListener('close', () => { trigger?.focus(); });
  items.forEach(item => item.addEventListener('change', update));
  form.addEventListener('submit', async event => {
    const selected = items.filter(i => i.checked);
    if (!selected.length || submitting) { event.preventDefault(); return; }
    if (!live) { event.preventDefault(); return; }
    if (selected.length === 3) {
      if (!form.dataset.expires || Date.now() >= Number(form.dataset.expires)*1000) {
        event.preventDefault(); error.hidden=false; error.textContent='Promocja zakończyła się. Odśwież stronę, aby zobaczyć aktualną ofertę.'; return;
      }
      submitting=true; update();
      return;
    }
    event.preventDefault();
    const properties = {};
    form.querySelectorAll('input[name^="properties["]:not(:disabled)').forEach(input => {
      const key = input.name.slice(11, -1);
      if (input.value) properties[key] = input.value;
    });
    const payload = selected.map(item => ({id:item.dataset.variantId,quantity:1,properties}));
    submitting=true; update();
    const cartRoot = window.Shopify?.routes?.root || '/';
    try {
      const response = await fetch(cartRoot+'cart/add.js', {
        method:'POST', headers:{'Content-Type':'application/json','Accept':'application/json'},
        body:JSON.stringify({items:payload})
      });
      const result = await response.json();
      if (!response.ok) throw new Error(typeof result.description === 'string' ? result.description : 'Nie udało się dodać produktów. Sprawdź ich dostępność.');
      window.location.assign(cartRoot+'cart');
    } catch (cause) {
      submitting=false; update(); error.hidden=false;
      error.textContent=cause instanceof TypeError ? 'Nie udało się potwierdzić dodania produktów. Sprawdź koszyk przed ponowną próbą.' : cause.message;
    }
  });
  document.querySelectorAll('[data-bundle-direct]').forEach(button => button.addEventListener('click', () => {
    if (submitting) return; trigger=button; reset(); form.requestSubmit();
  }));
  addEventListener('pageshow', () => { submitting=false; submit.textContent='Dodaj zestaw do koszyka'; update(); });
})();
